import { emailField } from "./emailField"
import { languageField } from "./languageField"
import { phoneField } from "./phoneField"
import { stringField } from "./stringField"

const validators = { emailField, stringField, phoneField, languageField }

export default validators
